<template>
  <div>
    <div
        class="overflow-auto h-[100vh] fixed flex flex-col overflow-auto justify-start min-w-[300px] w-[300px] px-3 2xl:px-6  bg-dark scrollable-content border-pagebg  py-3 overflow-y-auto pb-2 shadow-lg top-0">
      <div class="h-28">
        <router-link :to="{name: 'home'}">
          <img class="mx-auto w-[200px] -mt-12" src="@/assets/img/logo_final3.svg">
        </router-link>
      </div>

      <div
          v-if="(authStore.user.hasDomesticRoadOrderEntry && KPN.DOMESTICROAD_DOMESTICTRANSPORT_PAGEACTION_ADDNEWORDER_ENABLED)  ||
           (authStore.user.hasInternationalRoadOrderEntry && KPN.INTERNATIONALROAD_INTERNATIONALROAD_PAGEACTION_ADDNEWORDER_ENABLED) ||
           (authStore.user.hasStrongoOrderEntry && KPN.STRONGO_STRONGO_PAGEACTION_ADDNEWORDER_ENABLED)"
          class="mt-5">
        <MainButton type="secondary" class="w-full text-center" @click="buttonaddNewOrder">
          <span class="text-center w-full">Add new order</span>
        </MainButton>
      </div>
      <div class="flex flex-col w-full space-y-2 mb-12">
        <div class="ml-2 flex flex-col text-white space-y-3 mb-6">
          <p class="text-md font-medium text-white lg:hidden">Hello {{ authStore.user?.first_name }}</p>
        </div>
        <router-link :to="{name: 'home'}" @click="close">
          <div
            v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_DASHBOARD_ENABLED])"
              :class="routeName === 'home' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '"
              class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer">
            <IconDashboard/>
            <span>Dashboard</span>
          </div>
        </router-link>
        <div @click="menu_transport = !menu_transport"
             class="flex justify-between items-center text-light fill-white hover:opacity-60 hover:bg-dark2 p-3 rounded-md w-full cursor-pointer"
             v-if="authStore.accountPermissions.allowedAny([KPN.AIR_AIR_ENABLED,
            KPN.OCEAN_OCEANTRANSPORT_ENABLED,
            KPN.INTERNATIONALROAD_INTERNATIONALROAD_ENABLED,
            KPN.DOMESTICROAD_DOMESTICTRANSPORT_ENABLED,
            KPN.STRONGO_STRONGO_ENABLED
            ])">
          <div class="flex space-x-4 w-full items-center">
            <IconTransport/>
            <span>Transport</span>
          </div>
          <div class="">
            <img class="transition-all" :class="menu_transport ? 'rotate-0' : 'rotate-180' "
                 src="@/assets/img/arrow_small.svg">
          </div>
        </div>
        <Transition name="slide-fade" appear>
          <div v-if="menu_transport" class="ml-3">
            <router-link :to="{name: 'international-shipments'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([ KPN.INTERNATIONALROAD_INTERNATIONALROAD_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'international-shipments' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconTransportInternationalRoad/>
                <span>International Road</span>
              </div>
            </router-link>
            <router-link :to="{name: 'domestic-shipments'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([ KPN.DOMESTICROAD_DOMESTICTRANSPORT_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'domestic-shipments' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconTransportDomesticRoad/>
                <span>Domestic Road</span>
              </div>
            </router-link>
            <router-link :to="{name: 'strongo-shipments'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([ KPN.STRONGO_STRONGO_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'strongo-shipments' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconStrongo/>
                <span>Strongo</span>
              </div>
            </router-link>
            <router-link :to="{name: 'ocean'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([KPN.OCEAN_OCEANTRANSPORT_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'ocean' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconTransportOcean/>
                <span>Ocean</span>
              </div>
            </router-link>
            <router-link :to="{name: 'air'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([KPN.AIR_AIR_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'air' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconTransportAir/>
                <span>Air</span>
              </div>
            </router-link>
          </div>
        </Transition>
        <div @click="menu_rapoarte = !menu_rapoarte"
             class="flex justify-between items-center text-light fill-white hover:opacity-60 hover:bg-dark2 p-3 rounded-md w-full cursor-pointer"
             v-if="authStore.accountPermissions.allowedAny([KPN.WAREHOUSING_WAREHOUSINGORDERS_ENABLED, KPN.WAREHOUSING_WAREHOUSINGRECEPTIONRETURN_ENABLED])">
          <div class="flex space-x-4 w-full ">
            <IconWarehousing/>
            <span>Warehousing</span>
          </div>
          <div class="">
            <img class="transition-all" :class="menu_rapoarte ? 'rotate-0' : 'rotate-180' "
                 src="@/assets/img/arrow_small.svg">
          </div>
        </div>
        <Transition name="slide-fade" appear>
          <div v-if="menu_rapoarte" class="ml-3">
            <router-link :to="{name: 'vbs-inbounds'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([KPN.WAREHOUSING_WAREHOUSINGRECEPTIONRETURN_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'vbs-inbounds' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconWarehousingReception/>
                <span>Reception/Return</span>
              </div>
            </router-link>
            <router-link :to="{name: 'vbs-outbounds'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([KPN.WAREHOUSING_WAREHOUSINGORDERS_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'vbs-outbounds' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconWarehousingOrder/>
                <span>Orders</span>
              </div>
            </router-link>
          </div>
        </Transition>
        <div @click="menu_depozit = !menu_depozit"
             class="flex justify-between items-center text-light fill-white hover:opacity-60 hover:bg-dark2 p-3 rounded-md w-full cursor-pointer"
             v-if="authStore.accountPermissions.allowedAny([KPN.WAREHOUSINGSIMPLIFY_WAREHOUSINGSIMPLIFY_ENABLED,
            KPN.WAREHOUSINGSIMPLIFY_WAREHOUSINGSIMPLIFYORDER_ENABLED,
            KPN.WAREHOUSINGSIMPLIFY_WAREHOUSINGSIMPLIFYRECEPTIONRETURN_ENABLED,
            ])">
          <div class="flex space-x-4 w-full ">
            <IconWarehousingSimplify/>
            <span>Warehousing Simplify</span>
          </div>
          <div class="">
            <img class="transition-all" :class="menu_depozit ? 'rotate-0' : 'rotate-180' "
                 src="@/assets/img/arrow_small.svg">
          </div>
        </div>
        <Transition name="slide-fade" appear>
          <div v-if="menu_depozit" class="ml-3">
            <router-link :to="{name: 'inbounds'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([KPN.WAREHOUSINGSIMPLIFY_WAREHOUSINGSIMPLIFYRECEPTIONRETURN_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'inbounds' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconWarehousingSimplifyReception/>
                <span>Reception/Return</span>
              </div>
            </router-link>
            <router-link :to="{name: 'outbounds'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([KPN.WAREHOUSINGSIMPLIFY_WAREHOUSINGSIMPLIFYORDER_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer items-center my-2"
                   :class="routeName === 'outbounds' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconWarehousingSimplifyOrder/>
                <span>Orders</span>
              </div>
            </router-link>
          </div>
        </Transition>
        <div @click="menu_erp = !menu_erp"
             class="flex justify-between items-center text-light fill-white hover:opacity-60 hover:bg-dark2 p-3 rounded-md w-full cursor-pointer"
             v-if="authStore.accountPermissions.allowedAny([KPN.ERP_INVOICES_ENABLED])">
          <div
              class="flex space-x-4 w-full ">
            <IconInvoices/>
            <span>Invoices</span>
          </div>
          <div class="">
            <img class="transition-all" :class="menu_erp ? 'rotate-0' : 'rotate-180' "
                 src="@/assets/img/arrow_small.svg">
          </div>
        </div>
        <Transition
            name="slide-fade" appear>
          <div v-if="menu_erp " class="ml-3">
            <router-link :to="{name: 'customers'}" @click="close"
                         v-if="authStore.accountPermissions.allowedAny([KPN.ERP_INVOICES_ENABLED])">
              <div class="flex space-x-4 w-full p-3 rounded-md  cursor-pointer items-center my-2"
                   :class="routeName === 'customers' ? ' text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
                <IconIssuedByKlg/>
                <span>Issued by KLG</span>
              </div>
            </router-link>
          </div>
        </Transition>
        <router-link :to="{name: 'users'}" @click="close"
                     v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_USERS_ENABLED])">
          <div
              :class="routeName === 'users' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '"
              class="flex space-x-5 w-full p-3 rounded-md cursor-pointer">
            <IconUsers/>
            <span>Users</span>
          </div>
        </router-link>
        <router-link :to="{name: 'roles-permissions'}" @click="close"
                     v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_ROLESANDPERMISSIONS_ENABLED])">
          <div
              :class="routeName === 'roles-permissions' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '"
              class="flex space-x-4 w-full p-3 rounded-md cursor-pointer">
            <IconRolesAndPermissions/>
            <span>Roles & Permissions</span>
          </div>
        </router-link>
        <router-link :to="{name: 'activity-log'}" @click="close"
                     v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_ACTIVITYLOG_ENABLED])">
          <div
              :class="routeName === 'activity-log' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '"
              class="flex space-x-4 w-full  p-3 rounded-md cursor-pointer">
            <IconActivityLog/>
            <span>Activity Log</span>
          </div>
        </router-link>
        <div>
          <router-link :to="{name: 'claims'}" @click="close"
                       v-if="authStore.accountPermissions.allowedAny([KPN.CLAIMS_CLAIMS_ENABLED])">
            <div class="flex space-x-3 w-full px-3 rounded-md cursor-pointer items-center"
                 :class="routeName === 'tickets' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '">
              <IconClaims/>
              <span>Claims</span>
            </div>
          </router-link>
        </div>
        <router-link :to="{name: 'docs'}" @click="close">
          <div
              v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_APIDOCS_ENABLED])"
              :class="routeName === 'docs' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '"
              class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer">
            <IconApiDocs/>
            <span>API Docs</span>
          </div>
        </router-link>
        <router-link :to="{name: 'documentation'}" @click="close">
          <div
              v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_DASHBOARD_ENABLED])"
              :class="routeName === 'documentation' ? 'bg-dark2 text-white fill-secondary transition-all duration-300 ease-in-out' : '  text-light fill-white hover:fill-secondary hover:opacity-60 hover:bg-dark2 transition-all duration-300 ease-in-out '"
              class="flex space-x-4 w-full p-3 rounded-md w-full cursor-pointer">
            <IconApiDocs/>
            <span>User Manual</span>
          </div>
        </router-link>

      </div>
    </div>
    <div class="fixed left-0 right-0 bottom-0 top-0 bg-black bg-opacity-40 z-50" v-if="add_new_order">
      <div
          class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bottom-0 bg-white z-10 w-full max-w-[600px] h-96 rounded-md">
        <div @click="closeNewOrder" class="right-4 top-4 absolute cursor-pointer hover:fill-secondary">
          <Close></Close>
        </div>
        <div class="flex flex-col justify-center items-center px-6 h-full">
          <p class="font-bold text-2xl">Add New Order</p>
          <div class="flex justify-between gap-3 mt-10">
            <div
                v-if="authStore.user.hasDomesticRoadOrderEntry  && KPN.DOMESTICROAD_DOMESTICTRANSPORT_PAGEACTION_ADDNEWORDER_ENABLED"
                class="flex justify-center items-center flex-col border rounded-md p-6 bg-[#F8FAFB80] space-y-4">
              <IconDomesticRoad class="fill-accent w-16 h-16"></IconDomesticRoad>
              <p class="text-lg font-bold text-dark text-center">Domestic Road</p>
              <RouterLink :to="{name:'order-entry-domestic-road-transport'}">
                <MainButton
                  @click="closeNewOrder"
                  :disabled="authStore.user.companyBlockedInErp"
                  :tooltip="authStore.user.companyBlockedInErp ? blockedCompanyTooltip : ''">
                  Select
                </MainButton>
              </RouterLink>
            </div>
            <div
                v-if="authStore.user.hasInternationalRoadOrderEntry && KPN.INTERNATIONALROAD_INTERNATIONALROAD_PAGEACTION_ADDNEWORDER_ENABLED"
                class="flex justify-center items-center flex-col border rounded-md p-6 bg-[#F8FAFB80] space-y-4">
              <IconInternationalRoad class="fill-accent w-16 h-16"></IconInternationalRoad>
              <p class="text-lg font-bold text-dark text-center">International Road</p>
              <RouterLink :to="{name:'order-entry-international-road-transport'}">
                <MainButton
                  @click="closeNewOrder"
                  :disabled="authStore.user.companyBlockedInErp"
                  :tooltip="authStore.user.companyBlockedInErp ? blockedCompanyTooltip : ''">
                  Select
                </MainButton>
              </RouterLink>
            </div>
            <div
                v-if="authStore.user.hasStrongoOrderEntry && KPN.INTERNATIONALROAD_INTERNATIONALROAD_PAGEACTION_ADDNEWORDER_ENABLED"
                class="flex justify-center items-center flex-col border rounded-md p-6 bg-[#F8FAFB80] space-y-7">
              <IconStrongo class="fill-accent w-16 h-16"></IconStrongo>
              <p class="text-lg font-bold text-dark text-center">Strongo</p>
              <RouterLink :to="{name:'order-entry-strongo-transport'}">
                <MainButton
                  @click="closeNewOrder"
                  :disabled="authStore.user.companyBlockedInErp"
                  :tooltip="authStore.user.companyBlockedInErp ? blockedCompanyTooltip : ''">
                  Select
                </MainButton>
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {ref, computed} from 'vue';
import {useRoute} from "vue-router";
import {useAuthStore} from "@/stores/auth";
import {KPN} from "@/types/KPN"
import userManualPDF from '@/assets/img/user_manual.pdf';
import MainButton from "@/components/buttons/MainButton.vue";
import Close from "@/components/svg_icons/Close.vue";
import IconDomesticRoad from "@/components/svg_icons/IconDomesticRoad.vue";
import IconInternationalRoad from "@/components/svg_icons/IconInternationalRoad.vue";
import IconInvoices from "@/components/svg_icons/IconInvoices.vue";
import IconIssuedByKlg from "@/components/svg_icons/IconIssuedByKlg.vue";
import IconDashboard from "@/components/svg_icons/IconDashboard.vue";
import IconUsers from "@/components/svg_icons/IconUsers.vue";
import IconActivityLog from "@/components/svg_icons/IconActivityLog.vue";
import IconRolesAndPermissions from "@/components/svg_icons/IconRolesAndPermissions.vue";
import IconWarehousing from "@/components/svg_icons/IconWarehousing.vue";
import IconWarehousingReception from "@/components/svg_icons/IconWarehousingReception.vue";
import IconWarehousingOrder from "@/components/svg_icons/IconWarehousingOrder.vue";
import IconWarehousingSimplify from "@/components/svg_icons/IconWarehousingSimplify.vue";
import IconWarehousingSimplifyReception from "@/components/svg_icons/IconWarehousingSimplifyReception.vue";
import IconWarehousingSimplifyOrder from "@/components/svg_icons/IconWarehousingSimplifyOrder.vue";
import IconTransport from "@/components/svg_icons/IconTransport.vue";
import IconTransportDomesticRoad from "@/components/svg_icons/IconTransportDomesticRoad.vue";
import IconTransportInternationalRoad from "@/components/svg_icons/IconTransportInternationalRoad.vue";
import IconTransportOcean from "@/components/svg_icons/IconTransportOcean.vue";
import IconTransportAir from "@/components/svg_icons/IconTransportAir.vue";
import IconUserManul from "@/components/svg_icons/IconUserManul.vue";
import IconApiDocs from "@/components/svg_icons/IconApiDocs.vue";
import IconStrongo from "@/components/svg_icons/IconStrongo.vue";
import IconClaims from "@/components/svg_icons/IconClaims.vue";

const authStore = useAuthStore();
const menu_transport = ref(true);
const menu_depozit = ref(true);
const menu_rapoarte = ref(true);
const menu_erp = ref(true);
const add_new_order = ref(false);
const route = useRoute();
const emit = defineEmits(['update:modelValue']);

const blockedCompanyTooltip = 'Your account is currently blocked in our ERP system. ' +
  'Please contact your KLG Sales Representative or Key Account Manager before submitting any orders through Order Entry.';

const routeName = computed(() => {
  return route.name;
});

const close = () => {
  // console.log('minus');
  if (window.innerWidth < 1025) {
    emit('update:modelValue', false);
    // console.log('minuus');
    document.body.classList.remove('lock_body_scroll');
  }
}

const buttonaddNewOrder = () => {
  add_new_order.value = true;
  document.body.classList.add('lock_body_scroll');
}

const closeNewOrder = () => {
  add_new_order.value = false;
  document.body.classList.remove('lock_body_scroll');
}

const openPDF = () => {
  window.open(userManualPDF, '_blank');
};

</script>
